const controllerMap = new Map<string, AbortController>();

export const cancelRequest = (key: string) => {
  if (controllerMap.has(key)) {
    controllerMap.get(key)?.abort();
    controllerMap.delete(key);
  }
};

export const createCancelableRequest = (key: string): AbortSignal => {
  cancelRequest(key);
  const controller = new AbortController();
  controllerMap.set(key, controller);
  return controller.signal;
};

export const API_CANCEL_KEYS = {
  STOCKINGS__PRODUCTION_LIST: 'stockings__production-list',
};
